import React, { useContext } from "react";
import NavMenu from "../components/nav-menu/NavMenu";
import Helmet from "react-helmet";

import OptimizeScrap from "../components/optimize-scrap/OptimizeScrap";
import OpinionSlider from "../components/opinion-slider/OpinionSlider";
import HomepageWidget from "../components/homepage-widget/HomepageWidget";

import Footer from "../components/main-page/sections/footer/Footer";

import * as actions from "../action";
import { connect } from "react-redux";
import { I18nextProvider } from "react-i18next";
import i18n from "../i18n/i18n";
import DomainContext from "../context/DomainContext";

import AdvantagesBanner from "../components/advantages-banner/AdvantagesBanner";
import GroupLegal from "../components/group-legal/GroupLegal";

import styles from "./layout.module.scss";
import MarketInsights from "../components/main-page/sections/marketInsights/MarketInsights";

import IncreaseRevenue from "../components/main-page/sections/increaseRevenue/IncreaseRevenue";

import MarketUpdatePopUp from "../components/main-page/popUp/marketUpdatePopUp";
export const ProductListContext = React.createContext({});

const getPathName = () => {
  if (typeof window !== "undefined") {
    const pathname = window.location.pathname;
    var path = pathname && pathname.replace(/\//g, "");

    if (path[path.length - 1] == "s") {
      path = path + "e";
    }

    return path;
  }
  return "";
};

class PreislandingLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      elementsLoaded: 0,
      homeUrl: "",
      showEuropeanMap: false,
    };
  }

  componentDidMount() {
    this.props.getProductList();
    this.props.getCategoryList();
  }

  render() {
    const {
      productList,
      getProductData,
      productData,
      domain,
      children,
      categoryList,
    } = this.props;
    const productPriceLabel = getPathName();

    return (
      <I18nextProvider i18n={i18n} defaultNS={"default"}>
        <NavMenu />
        <div className={styles.breadcrumb}>
          <a href="/">Home</a>
          <span className={styles.separator}>/ </span>
          <span>{productPriceLabel}</span>
        </div>
        <HomepageWidget
          productList={productList}
          getProductData={getProductData}
          productData={productData}
          variation="pricePage"
          productPriceLabel={productPriceLabel}
        />
        <ProductListContext.Provider
          value={{ productList: productList, categoryList: categoryList }}
        >
          {children}
        </ProductListContext.Provider>

        <OptimizeScrap />

        <OpinionSlider />
        <AdvantagesBanner />
        <Footer domain={domain} />
        <GroupLegal />
      </I18nextProvider>
    );
  }
}

function mapStateToProps({ products }) {
  return {
    productList: products.rawProductList,
    categoryList: products.categoryList,
  };
}
export function PreislandingLayoutWithContext(props) {
  const domain = useContext(DomainContext);

  return <PreislandingLayout {...props} domain={domain} />;
}

export default connect(mapStateToProps, actions)(PreislandingLayoutWithContext);
